import {useState, React, useEffect} from "react";
import _ from "lodash";
import {Form} from "react-bootstrap";
import {Checkbox} from "primereact/checkbox";


export const Filter = ({filters,  filterType, checkedFiltersObject, setCheckedFiltersObject}) => {

    const [filterListGrouped, setFilterListGrouped] = useState([])

    const isCheck = (id) => {
        for(let i =0; i < checkedFiltersObject[filterType].length; i++){
            if(checkedFiltersObject[filterType][i].Id ===id){
                return true;
            }
        }
        return false
    }

    const handleFilterChange = (e) => {
        console.log(e.target.id)
        console.log(e.target.checked)

        let isExist = _.find(checkedFiltersObject[filterType], ['Id', e.target.id]);
        let deepClone = _.cloneDeep(checkedFiltersObject);

        if(e.target.checked && !isExist){
            const filterModel = {Id: e.target.id, Name: e.target.value};
            deepClone[filterType].push(filterModel)
            setCheckedFiltersObject(deepClone);
        }
        else if(!e.target.checked && isExist){
            _.remove(deepClone[filterType], function(n) {
                return n.Id === e.target.id
            });
            setCheckedFiltersObject(deepClone);
        }
    }

    if(!filters){
        return (<div></div>)
    }

    return (
        <div>
            {filters.map((filter, index) =>
                <div key={filter.Id.toString()}>

                    <Checkbox onChange={handleFilterChange} type="checkbox" id={filter.Id} value={filter.Name} label={filter.Name}  checked={isCheck(filter.Id)} />
                    <label htmlFor="ingredient1" className="ml-2">{filter.Name}</label>
                </div>
        )}
        </div>
    )
}